import { makeAutoObservable } from 'mobx';

class NoteStore {
  note = '';

  constructor() {
    makeAutoObservable(this);
  }

  setNote(value: string) {
    this.note = value;
  }
}

export default NoteStore;
